import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Typography,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@mui/material/Slide";

import TopButton from "../../Components/UI/TopButtons";
import Placeholder from "../../Components/UI/Placeholder";

import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { getEvaluateLearnerData } from "./Services";
import { joinByKeys, getClassNames } from "../../Js/Common";
import { find } from "lodash";

const AssessLearnerList = (props) => {
  //Hooks
  const styles = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);

  // State
  const [learners, setLearners] = useState([]);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    console.log("paramsdata=====>", paramsdata);
    const getLearners = async () => {
      let learnerData = await getEvaluateLearnerData(
        paramsdata.assetId,
        paramsdata.taskId,
        paramsdata.assignmentId,
        userInfo.site_uuid
      );
      console.log("learnerData", learnerData);
      setLearners(learnerData.data);
      setClasses(await getClassNames(userInfo.site_uuid));
      // dispatch(assessSliceActions.resetState());
      // dispatch(assessSliceActions.setDurationFlag(false));
    };
    getLearners();
  }, [paramsdata]);

  // Route redirect function
  const goTo = (userId, learnerName) => {
    dispatch(
      commonSliceActions.setParamsData({
        ...paramsdata,
        userId: userId,
        learnerName: learnerName,
      })
    );
    navigation(`/Assess/AssetTypes`);
  };

  // Get class name for given id
  const getClassNameFromUid = (id) => {
    if (id) {
      let classname = find(classes, { id: id });
      if (classname) {
        return classname.value;
      } else {
        return null;
      }
    }
  };
  return (
    <>
      <TopButton
        title={`Evaluate - (Assignment Name: ${paramsdata.assignmentName})`}
        secondaryText={`Learner List ( Asset Name: ${paramsdata.assetName} )`}
        // isReportFilter={true}
        // handleFilter={handleFilterData}
      />
      <Grid
        container
        spacing={2}
        className={styles.scrollBar}
        sx={{
          px: 5,
          height: "75vh",
          overflow: "auto",
          justifyContent: "flex-start",
          alignContent: "flex-start",
        }}
      >
        {learners &&
          learners.length > 0 &&
          learners.map((learnerData, index) => {
            return (
              <Slide
                direction="up"
                timeout={500}
                in={true}
                mountOnEnter
                unmountOnExit
              >
                <Grid item xs={6} sx={{ mt: 2 }} key={`${"learner_" + index}`}>
                  <List sx={{ margin: "0px !important" }}>
                    <ListItem
                      disablePadding
                      sx={{
                        borderRadius: 2,
                        padding: "0px",
                        backgroundColor: "#F5F7FF",
                      }}
                      onClick={() => {
                        goTo(learnerData.uid, learnerData.name);
                      }}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          au6ria-label="comments"
                          sx={{
                            color: "primary.main",
                            backgroundColor: "#FFFFFF",
                          }}
                        >
                          <NavigateNextIcon
                            sx={{
                              fontSize: "1.2rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "2rem",
                              },
                            }}
                          />
                        </IconButton>
                      }
                      // className={`${(selectedQType == insightData.type) ? styles.activeText : ""}`}
                    >
                      <ListItemButton sx={{ borderRadius: 5 }} dense>
                        <ListItemText sx={{ color: "primary.main" }}>
                          <Typography
                            sx={{
                              fontSize: "0.95rem",
                              fontWeight: "600",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {joinByKeys(
                              learnerData.name,
                              ["firstname", "lastname"],
                              " "
                            )}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#a9a9a9",
                              fontWeight: "600",
                              fontSize: "0.8rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "1rem",
                              },
                            }}
                          >
                            {`Class : ${getClassNameFromUid(
                              learnerData.belongs_to
                            )}`}
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Grid>
              </Slide>
            );
          })}
        {!learners ||
          (learners.length == 0 && (
            <Placeholder
              primaryText="No learners!"
              secondaryText="No learners available for evaluation"
              image="assign"
            ></Placeholder>
          ))}
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
  activeText: {
    backgroundColor: "#d7e2f2",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default AssessLearnerList;
